import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-683ff10a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Sidebar__inner" }
const _hoisted_2 = {
  key: 0,
  class: "logo__text"
}
const _hoisted_3 = { class: "Sidebar__links" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fa-sm link__icon" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "link__name"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 2,
  class: "link__name"
}
const _hoisted_9 = {
  key: 3,
  class: "p-1 rounded bg-blue-500 text-blue-100 text-xs ml-3"
}
const _hoisted_10 = {
  key: 1,
  class: "links__parent"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  class: "trigger__name"
}
const _hoisted_14 = {
  key: 3,
  class: "p-1 rounded bg-blue-500 text-blue-100 text-xs ml-3"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 2,
  class: "child__name"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['Sidebar', { 'Sidebar-closed': !_ctx.isOpened }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getLogoClass)
      }, [
        (_ctx.isOpened)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.getLogoText), 1))
          : _createCommentVNode("", true),
        (_ctx.isOpened)
          ? (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: "fas fa-outdent fa-lg logo__icon",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
            }))
          : (_openBlock(), _createElementBlock("i", {
              key: 2,
              class: "fas fa-bars fa-lg logo__icon",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
            }))
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayed_links, (link) => {
          return (_openBlock(), _createElementBlock("div", {
            key: link.id
          }, [
            (!link.sub_links.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (link.isOther)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: _normalizeClass(['links__link', { 'links__link-closed': !_ctx.isOpened }]),
                        href: link.url,
                        target: "_blank"
                      }, [
                        _hoisted_5,
                        (_ctx.isOpened)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(link.name), 1))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_4))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        class: _normalizeClass(['links__link', { 'links__link-closed': !_ctx.isOpened }]),
                        to: link.url
                      }, {
                        default: _withCtx(() => [
                          (link.icon_custom)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: `/icons/${link.icon_custom}`,
                                alt: "icon_custom",
                                class: "icon_custom"
                              }, null, 8, _hoisted_7))
                            : (_openBlock(), _createElementBlock("i", {
                                key: 1,
                                class: _normalizeClass(link.icon)
                              }, null, 2)),
                          (_ctx.isOpened)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(link.name), 1))
                            : _createCommentVNode("", true),
                          (_ctx.isOpened && link.is_beta)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, " BETA "))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["class", "to"]))
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                                    'parent__trigger',
                                    { 'parent__trigger-closed': !_ctx.isOpened },
                                ]),
                    onClick: ($event: any) => (_ctx.openParent(link.id))
                  }, [
                    (link.icon_custom)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: `/icons/${link.icon_custom}`,
                          alt: "icon_custom",
                          class: "icon_custom"
                        }, null, 8, _hoisted_12))
                      : (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: _normalizeClass(link.icon)
                        }, null, 2)),
                    (_ctx.isOpened)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(link.name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isOpened && link.is_beta)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, " BETA "))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_11),
                  _createElementVNode("div", {
                    class: _normalizeClass(["parent__childs", { 'parent--opened': link.id === _ctx.opened_parent }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.sub_links, (sub_link) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        class: "childs__link",
                        key: sub_link.id,
                        to: sub_link.url
                      }, {
                        default: _withCtx(() => [
                          (sub_link.icon_custom)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: `/icons/${sub_link.icon_custom}`,
                                alt: "icon_custom",
                                class: "icon_custom"
                              }, null, 8, _hoisted_15))
                            : (_openBlock(), _createElementBlock("i", {
                                key: 1,
                                class: _normalizeClass(sub_link.icon)
                              }, null, 2)),
                          (_ctx.isOpened)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(sub_link.name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ], 2)
                ]))
          ]))
        }), 128)),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            class: _normalizeClass(['links__link', { 'links__link-closed': !_ctx.isOpened }]),
            href: "https://dostavka.atlassian.net/servicedesk/customer/portals",
            rel: "nofollow, noreferrer",
            target: "_blank"
          }, [
            _hoisted_17,
            (_ctx.isOpened)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["link__name", _ctx.isOpened ? 'link__name' : 'link__name-closed'])
                }, " Портал поддержки ", 2))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("a", {
            class: _normalizeClass(['links__link', { 'links__link-closed': !_ctx.isOpened }]),
            href: "https://dostavka.atlassian.net/servicedesk/customer/portal/3/article/30081230",
            rel: "nofollow, noreferrer",
            target: "_blank"
          }, [
            _hoisted_18,
            (_ctx.isOpened)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["link__name", _ctx.isOpened ? 'link__name' : 'link__name-closed'])
                }, " База знаний ", 2))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ])
  ], 2))
}